import { render, staticRenderFns } from "./PromotionListDetails.vue?vue&type=template&id=0fcd484e"
import script from "./PromotionListDetails.vue?vue&type=script&lang=js"
export * from "./PromotionListDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports